import { Box, Container, Text } from '@chakra-ui/react';

const PageUnavailableMsg = ({ isDemoAccount }: { isDemoAccount: boolean }) => {
  const userTypeStr = isDemoAccount ? 'デモ' : '法人';
  return (
    <Box mt={20}>
      <Container
        maxW="lg"
        p={4}
        borderWidth={1}
        borderColor="lightgray"
        borderRadius={8}
      >
        <Text textAlign="center">{`${userTypeStr}アカウントのため表示できません`}</Text>
      </Container>
    </Box>
  );
};

export default PageUnavailableMsg;
